<template>
	<div class="container bg_main">

		<div @click="getWxAddr" class="hidden flex_row bg_white">
			<div>获取微信地址</div>
			<div>
				<img src="@/assets/images/arrow_right.png" mode="widthFix" class="width18 height18 padding5" />
			</div>
		</div>

		<div class="fullwidth padding15">
				<div class="flex_row bg_white radius10">
					<div @click="reloadList">
						<div class="uni-icon uni-icon-contact marginr5 middle"></div>
						<div class="inline middle">我的地址</div>
					</div>
					<div @click="toEdit" class="uni-icon uni-icon-plus "></div>
				</div>
		</div>

		<div class="fullwidth padding015">

				<div v-if="contactList.length==0" class="center padding50 fullwidth">
					<div @click="toEdit" class="size100r color_green uni-icon uni-icon-plus"></div>
				</div>

			
				<div v-for="(item,index) in contactList" v-bind:key="index" class="fullwidth padding10 marginb10 radius10 bg_white border">
					<div class="fullwidth">
						<div @click="selectAddr(item)" class="fullwidth flex_row_s padding0 ">
							<div class="inline">
								<img src="@/assets/images/marker.png" class="btn4 middle" />
							</div>
							<div class=" inline size3">{{item.area}}{{item.address}}</div>
						</div>
						<div @click="selectAddr(item)" class="fullwidth">
							<div class="item_title size5 color2 inline">收货人</div>
							<div class=" inline size5">{{item.contacter}}</div>
						</div>
						<div class="fullwidth">
							<div class="item_title size5 color2 inline">收货电话</div>
							<div class=" inline size5">{{item.phone}}</div>
						</div>
					</div>
					<div class="btn_box flex_row padding0">

						<div class="flex1 center">
							<img @click="toEdit(item)" src="@/assets/images/edit.png" class="width30 height30 inline " />
						</div>
						<div class="flex1 center">
							<img @click="deleteContact(item)" src="@/assets/images/fail.png" class="width30 height30 inline " />
						</div>
						<div v-if="isFromOrder" class="flex1 center">
							<img @click="selectAddr(item)" src="@/assets/images/success.png" class="width30 height30 inline " />
						</div>

					</div>


				</div>

		</div>




	</div>
</template>

<script>
	import uniLoadMore from '@/components/uni-load-more/uni-load-more.vue';
	//
	// var app = getApp();

	export default {
		components: {
			uniLoadMore
		},
		data() {
			return {
				contactList: [],
				isFromOrder: false,

				//------------------
				banner: {},
				listData: [],
				page: 1,
				totalPage: 0,
				last_id: '',
				reload: false,
				status: 'more',
				adpid: '',
				contentText: {
					contentdown: '上拉加载更多',
					contentrefresh: '加载中',
					contentnomore: '没有更多'
				}
			};
		},
		created() {

			var options=this.$route.query || {};
			console.log(options,"-------------", this.$router);
			var action = options.action;
			if (action == 'from_order') {
				this.isFromOrder = true;
			}

			// uni.setNavigationBarColor({
			// 	frontColor: '#000000',
			// 	backgroundColor: app.statusBarBg,
			// 	animation: {
			// 		duration: 30,
			// 		timingFunc: 'linear'
			// 	}
			// });
			
			
			
		},
		mounted() {
			this.getContactList();
		},
		onPullDownRefresh() {
			this.getContactList();
			// uni.stopPullDownRefresh();
		},
		onReachBottom() {

		},
		methods: {
			
			reloadList(){
				//用户
				var user = window.$utils.uniapi.getStorageSync("user") || {};
				if (typeof user.id == "undefined" || user.id == null) {
					this.toLogin();
					return false;
				}
				this.getContactList();
			},
	
			getContactList() {
				console.log("创建订单");
				var that = this;

				//用户
				var user = window.$utils.uniapi.getStorageSync("user") || {};
				if (typeof user.id == "undefined" || user.id == null) {
					console.log("没有uid");
					return false;
				}
				//请求
				var params = {
					mid: user.id,
				};
				this.$axios.request({
						url: window.$config.url.getContactList,
						data: params
					})
					.then(res => {
						that.isLoadFinished = true;
						if (!!res.code == true && res.code == window.$config.resCode.SUCCESS) {
							var contactList = res.data.list;
							// if(!!contactList==false || contactList.length==0){
							// }
							that.contactList = contactList;
						} else if (!!res.msg == true) {
							alert( res.msg );
						} else {
							alert( "不成功" );
						}
					});

			},


			/**
			 * 选地址
			 */
			selectAddr: function(item) {
				var that = this;
				window.$utils.uniapi.setStorageSync('selectedContact', item);
				// this.$router.push({path:'/order_confirm',query:{}}); 
				this.$router.go(-1); 
				
				
			},



			toEdit(item) {
				//用户
				var user = window.$utils.uniapi.getStorageSync("user") || {};
				if (typeof user.id == "undefined" || user.id == null) {
					this.toLogin();
					return false;
				}
				if (!!item==true) {
					window.$utils.uniapi.setStorageSync('selectedContact', item);
				}
				var queryObj={};
				if(this.isFromOrder)queryObj.action=1;
				this.$router.push({path:'/order_addr_edit',query:queryObj}).catch(err => {
						// 忽略重复导航错误
						if (err.name !== 'NavigationDuplicated') {
							// 其他错误正常抛出
							throw err;
						}
					});; 
			},


			deleteContact(item) {
				console.log("收货地址");
				var that = this;
				//用户
				var user = window.$utils.uniapi.getStorageSync("user") || {};
				if (typeof user.id == "undefined" || user.id == null) {
					console.log("没有uid");
					return false;
				}
				var id = item.id;
				if (!!id == false) {
					console.log("没有id");
					return false;
				}
				//请求
				var params = {
					id: id
				};
				window.$utils.uniapi.showLoading({
					title: "加载中"
				});
				this.$axios.request({
						url: window.$config.url.deleteContact,
						data: params
					})
					.then(res => { 
						if (!!res.code == true && res.code == window.$config.resCode.SUCCESS) {
							alert("成功");
							that.getContactList();
						} else if (res.data.msg) {
							alert( res.data.msg );
						} else {
							alert('不成功' );
						}
					})

				//requestTask.abort() // 取消请求任务
			},


			toBack() {
				// uni.navigateBack({
				//   delta: 0,
				//   success: (res) => {},
				//   fail: (res) => {},
				//   complete: (res) => {},
				// })
			},



			//获取微信地址
			getWxAddr() {
				var that = this;
				// uni.chooseAddress({
				// 	success(res) {
				// 		var addr = {
				// 			area: res.provinceName + "," + res.cityName + "," + res.countyName,
				// 			address: res.detailInfo,
				// 			code: res.postalCode, //res.nationalCode,
				// 			name: res.userName,
				// 			phone: res.telNumber ? res.telNumber.replace("-", "") : "",
				// 			isWxAddr: 1,
				// 		}

				// 		that.saveContactForWx(addr);
				// 	},
				// 	fail() {
				// 		alert( '未选择微信地址' );
				// 	}

				// })
			},


			/**
			   * 
			   * @param {String account = request.getParameter("account");
						String name = request.getParameter("name");
						String longitude = request.getParameter("longitude");
						String latitude = request.getParameter("latitude");
						String address = request.getParameter("address");
						String phone = request.getParameter("phone");
						String landmark = request.getParameter("landmark");
						String area = request.getParameter("area"); } d 
			   */
			saveContactForWx(d) {
				console.log("收货地址");
				var that = this;
				//用户
				var user = window.$utils.uniapi.getStorageSync("user") || {};
				if (typeof user.id == "undefined" || user.id == null) {
					console.log("没有uid");
					return false;
				}
				//请求
				var id = 0;
				var params = {
					//id:id,
					account: user.id,
					address: d.address,
					contacter: d.name,
					phone: d.phone,
					code: d.code,
					defaultAddress: 1,
					area: d.area
				};
				window.$utils.uniapi.showLoading({
					title: "加载中"
				});
				this.$axios.request({
						url: window.$config.url.saveContact,
						data: params
					})
					.then(res => { 
						that.setData({
							isLoadFinished: true
						});
						if (!!res.code == true && res.code == window.$config.resCode.SUCCESS) {

							alert( "成功" );
							d.id = res.data.data;
							that.contactObj= d ;

							that.getContactList();
						}
					});


			},
			toLogin() {
				this.$router.push({ path: "/user_login" });
			}

		}
	};
</script>

<style scoped>
	.banner {
		height: 180px;
		overflow: hidden;
		position: relative;
		background-color: #ccc;
	}

	.banner-img {
		width: 100%;
	}

	.banner-title {
		max-height: 42px;
		overflow: hidden;
		position: absolute;
		left: 15px;
		bottom: 15px;
		width: 90%;
		font-size: 16px;
		font-weight: 400;
		line-height: 21px;
		color: white;
		z-index: 11;
	}

	.uni-media-list-logo {
		width: 90px;
		height: 70px;
	}

	.uni-media-list-body {
		height: auto;
		justify-content: space-around;
	}

	.uni-media-list-text-top {
		height: 37px;
		font-size: 14px;
		overflow: hidden;
	}

	.uni-media-list-text-bottom {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
	}
</style>


// WEBPACK FOOTER //
// src/views/order/addr_list.vue